import { AppState } from "../reducers";
import { createSelector } from "reselect";

export const getState = (state: AppState) => state.collections;

export const getCollections = createSelector([getState], (state) => state.collections.filter(collection => collection.id !== 20));
